const InstantBooking = ({ height = "16", width = "16", color = "currentColor" }) => (
  <svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
    <path
      d="M274.8 6.288C279.4 2.237 285.3 0 291.4 0C308.6 0 320.6 17.05 314.8 33.27L246.7 224H356.1C371.9 224 384 236.1 384 251C384 258.8 380.7 266.2 374.9 271.3L109.1 505.8C104.6 509.8 98.7 512 92.63 512C75.41 512 63.39 494.9 69.18 478.7L137.3 288H25.81C11.56 288 0 276.4 0 262.2C0 254.8 3.153 247.8 8.664 242.9L274.8 6.288zM275.4 48.65L42.08 256H160C165.2 256 170.1 258.5 173.1 262.8C176.1 267 176.8 272.5 175.1 277.4L108.6 463.6L343.8 256H224C218.8 256 213.9 253.5 210.9 249.2C207.9 244.1 207.2 239.5 208.9 234.6L275.4 48.65z"
      fill={color} // Set fill to the provided color
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

export default InstantBooking;
